
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/downloads",
      function () {
        return require("private-next-pages/about/downloads/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/downloads"])
      });
    }
  